// document.addEventListener("DOMContentLoaded", function () {
//     let productContainer = document.querySelector('.sf-mixed-layout__wrapper');

//     if (productContainer) {
//         let products = Array.from(productContainer.children); // Get all product elements
//         let shuffledProducts = products.sort(() => Math.random() - 0.5); // Randomize order

//         // Clear current products and append shuffled ones
//         productContainer.innerHTML = "";
//         shuffledProducts.forEach(product => productContainer.appendChild(product));
//     }
// });

// setTimeout(() => {
//     let productContainers = document.querySelectorAll('.sf-mixed-layout__wrapper');

//     productContainers.forEach(container => {
//         let products = Array.from(container.children);
//         let shuffledProducts = products.sort(() => Math.random() - 0.5);
        
//         container.innerHTML = "";
//         shuffledProducts.forEach(product => container.appendChild(product));
//     });
// }, 50); // Delay execution for 2 seconds


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sf-mixed-layout__wrapper').forEach(wrapper => {
    const isSwiper = wrapper.classList.contains('swiper-wrapper') || wrapper.closest('.swiper-wrapper');
    const products = isSwiper 
      ? Array.from(wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'))
      : Array.from(wrapper.children);

    if (products.length <= 1) return;

    const seen = new Set();
    const firstProducts = [], duplicateProducts = [];

    products.forEach(product => {
      let productKey = product.dataset.productId || 
                       product.dataset.productId__c || 
                       product.querySelector('a[href*="/products/"]')?.href.split('/products/').pop()?.split('?')[0];

      if (!productKey) productKey = product.textContent.trim().substring(0, 50);

      if (!seen.has(productKey)) {
        seen.add(productKey);
        firstProducts.push(product);
      } else {
        duplicateProducts.push(product);
      }
    });

    for (let i = firstProducts.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [firstProducts[i], firstProducts[j]] = [firstProducts[j], firstProducts[i]];
    }

    const arrangedProducts = firstProducts.concat(duplicateProducts);

    if (isSwiper) {
      const swiper = wrapper.closest('.swiper-container')?.swiper;
      if (swiper) {
        swiper.removeAllSlides();
        swiper.appendSlide(arrangedProducts);
        swiper.update();
      }
    } else {
      wrapper.innerHTML = '';
      arrangedProducts.forEach(product => wrapper.appendChild(product));
    }
  });
});

